import React, { useState } from 'react';
import { Input } from './ui/input';

/**
 * Currency input that allows negative values for "Troca com troco" scenarios.
 * Displays "R$ -1.234,56" or "R$ 1.234,56"
 * User can toggle sign with a checkbox or prefix button
 */
export default function SignedCurrencyInput({ value, onChange, placeholder, ...rest }) {
  const numValue = value === '' || value === null || value === undefined ? 0 : Number(value);
  const absValue = Math.abs(numValue);
  const isNegative = numValue < 0;

  const display = absValue === 0 && value === '' 
    ? '' 
    : absValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    if (!digits) {
      onChange('');
      return;
    }
    const limited = digits.slice(0, 13);
    const num = parseInt(limited, 10) / 100;
    // Apply current sign
    onChange(isNegative ? -num : num);
  };

  const toggleSign = () => {
    if (absValue === 0) return; // Don't toggle if zero
    onChange(isNegative ? absValue : -absValue);
  };

  const handleKeyDown = (e) => {
    if (
      e.key === 'Backspace' ||
      e.key === 'Delete' ||
      e.key === 'Tab' ||
      e.key === 'Enter' ||
      e.key.startsWith('Arrow') ||
      (e.ctrlKey || e.metaKey)
    ) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="flex gap-1">
      <div className="relative flex-1">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">
          R$ {isNegative ? '-' : ''}
        </span>
        <Input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          className={`${isNegative ? 'pl-12' : 'pl-9'} text-right tabular ${isNegative ? 'text-red-600 font-semibold' : ''}`}
          value={display}
          placeholder={placeholder || '0,00'}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          {...rest}
        />
      </div>
      {absValue > 0 && (
        <button
          type="button"
          onClick={toggleSign}
          className="px-3 py-2 text-xs font-medium rounded-md border border-border hover:bg-muted transition-colors whitespace-nowrap"
          title={isNegative ? 'Mudar para positivo (recebimento)' : 'Mudar para negativo (devolução)'}
        >
          {isNegative ? '→ Positivo' : '→ Negativo'}
        </button>
      )}
    </div>
  );
}
